module.exports = __webpack_public_path__ + "static/media/avolant.ce50d79a.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/climasense/aranha_roja_fresa/curativa/avolant.png
// module id = 1536
// module chunks = 3